import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import ENV from "../../../environment";
import Checkbox from "@mui/material/Checkbox";
import axios from "axios";
import "./style.css";
import { Button } from "@mui/material";
import Spinner from "react-spinner-material";

const HotelAmenities = () => {
    const { hotelid } = useParams();
    const [waiting, setWaiting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [archive, setArchive] = useState(false);
    const [data, setData] = useState([]);

    const getData = async () => {
        // setLoading(true);
        await axios
            .get(`${ENV.URL}/api/hdp/tts/adm/hotel/amenities/${hotelid}`, {
                headers: { Authorization: sessionStorage.getItem("token"), "client-id": ENV.CLIENTID, "client-secret": ENV.SECRET },
            })
            .then((res) => {
                setArchive(res.data.data.data.map((group) => ({ name: group.name, amenities: group.amenities.map((e) => ({ ...e })) })));
                setData(res.data.data.data.map((group) => ({ name: group.name, amenities: group.amenities.map((e) => ({ ...e })) })));
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                // toast.error(err?.response?.data?.errors[0]?.message || t("An error occurred"));
            });
    };

    useEffect(() => {
        getData();
    }, []);

    const handleChange = (event, id) => {
        if (updating)
            setData(
                data.map((group) => ({
                    name: group.name,
                    amenities: group.amenities.map((amenity) => {
                        if (amenity.id === id) amenity.have = event.target.checked;
                        return amenity;
                    }),
                }))
            );
    };

    const update = () => {
        setUpdating(true);
    };

    const cancel = () => {
        setUpdating(false);
        setData(archive.map((group) => ({ name: group.name, amenities: group.amenities.map((e) => ({ ...e })) })));
    };

    const submit = async () => {
        setWaiting(true);
        await axios
            .put(
                `${ENV.URL}/api/hdp/tts/adm/hotel/amenities/${hotelid}`,
                { data },
                { headers: { Authorization: sessionStorage.getItem("token"), "client-id": ENV.CLIENTID, "client-secret": ENV.SECRET } }
            )
            .then(() => {
                getData();
                setUpdating(false);
                setWaiting(false);
            })
            .catch((err) => {
                setWaiting(false);
                toast.error(err?.response?.data?.errors[0]?.message || "An error occurred");
            });
    };

    return (
        <div className="container mt-3">
            {loading ? (
                <div style={{ marginTop: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Spinner radius={150} color={"#1976d2"} stroke={16} visible={true} />
                </div>
            ) : (
                <React.Fragment>
                    {waiting && <div className="overlay"></div>}
                    {updating ? (
                        <div style={{ float: "right" }}>
                            <Button variant="outlined" color="error" onClick={cancel}>
                                Cancel
                            </Button>
                            <Button style={{ marginLeft: "10px" }} variant="outlined" color="primary" onClick={submit}>
                                Submit
                            </Button>
                        </div>
                    ) : (
                        <Button style={{ float: "right" }} variant="outlined" onClick={update}>
                            Update
                        </Button>
                    )}
                    {data.map((group) => (
                        <React.Fragment>
                            <h4 className="mt-4">{group.name}</h4>
                            <div className="hc-amenity no-select">
                                {group.amenities.map((amenity) => (
                                    <div>
                                        <FormControlLabel
                                            control={<Checkbox checked={amenity.have} onChange={(e) => handleChange(e, amenity.id)} />}
                                            label={amenity.name}
                                        />
                                    </div>
                                ))}
                            </div>
                        </React.Fragment>
                    ))}
                </React.Fragment>
            )}
        </div>
    );
};

export default HotelAmenities;
